// Helped class for User
export default class User {
  constructor (id) {
    this.id = id
  }
}



// WEBPACK FOOTER //
// ./src/store/user_help.js